import { TPersonType, TTenantRegister } from '../../core/types/Tenant'
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline'

interface ITabInfo {
  recipientData: TTenantRegister | null
  tabIndex: number
}

export const getSttingsTabsInfo = ({ recipientData, tabIndex }: ITabInfo) => [
  {
    index: 0,
    label:
      recipientData?.personType === TPersonType.Individual
        ? 'Pessoa Fisica'
        : 'Pessoa Juridica',
    icon: (
      <img
        src={`/assets/icons/user/userIcon${tabIndex === 0 ? 'Selected' : ''}.svg`}
        alt="User"
      />
    ),
  },
  {
    index: 1,
    label: 'Dados bancário',
    icon: (
      <img
        src={`/assets/icons/bank/bankIcon${tabIndex === 1 ? 'Selected' : ''}.svg`}
        alt="Bank"
      />
    ),
  },
  {
    index: 2,
    label: 'Saldo/Retirada',
    icon: (
      <img
        src={`/assets/icons/balance/balanceIcon${tabIndex === 2 ? 'Selected' : ''}.svg`}
        alt="Balance"
      />
    ),
  },
  {
    index: 3,
    label: 'APi de Integração',
    icon: (
      <img
        src={`/assets/icons/integration/integrationIcon${tabIndex === 3 ? 'Selected' : ''}.svg`}
        alt="Integration"
      />
    ),
  },
  {
    index: 4,
    label: 'Colaboradores',
    icon: (
      <PeopleOutlineIcon
        sx={{ color: tabIndex === 4 ? '#1C52BD' : '#323232' }}
      />
    ),
  },
]
